import r from"./fails.js";var t=r,e=!t(function(){return Object.defineProperty({},1,{get:function(){return 7}})[1]!=7});export{e as default};
